import type { FC } from 'react';
import { gql, useQuery } from '@apollo/client';

import { PageQuery, PageQueryVariables } from 'client/graphql/types/operations';

import useLanguage from 'utils/useLanguage';
import Markdown from './Markdown';
import Loader from './Loader';
import ScrollToElement from './ScrollToElement';

const PAGE_QUERY = gql`
  query PageQuery($id: String!, $language: Language!) {
    page(id: $id) {
      id
      content(language: $language)
    }
  }
`;

interface Props {
  id: string;
}

const PageContent: FC<Props> = (props) => {
  const { id } = props;

  const language = useLanguage();

  const { data, loading } = useQuery<PageQuery, PageQueryVariables>(
    PAGE_QUERY,
    {
      variables: {
        id,
        language,
      },
    },
  );

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Markdown className="PageContent">{data?.page?.content}</Markdown>

      <ScrollToElement />
    </>
  );
};

export default PageContent;
